/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * SEO
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetSeoMetaParams,
  SeoMeta,
  SeoOverride,
  SeoReport,
  UpdateAdminStoreSeo200
} from './model';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetSeoMetaUrl = (params: GetSeoMetaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/seo/meta?${stringifiedParams}` : `/api/seo/meta`
}

export const getSeoMeta = async (params: GetSeoMetaParams, options?: RequestInit): Promise<SeoMeta> => {

  return customFetch<SeoMeta>(getGetSeoMetaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSeoMetaQueryKey = (params?: GetSeoMetaParams,) => {
    return [
    `/api/seo/meta`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSeoMetaQueryOptions = <TData = Awaited<ReturnType<typeof getSeoMeta>>, TError = ErrorType<unknown>>(params: GetSeoMetaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSeoMeta>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeoMetaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeoMeta>>> = ({ signal }) => getSeoMeta(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeoMeta>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSeoMetaQueryResult = NonNullable<Awaited<ReturnType<typeof getSeoMeta>>>
export type GetSeoMetaQueryError = ErrorType<unknown>



export function useGetSeoMeta<TData = Awaited<ReturnType<typeof getSeoMeta>>, TError = ErrorType<unknown>>(
 params: GetSeoMetaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSeoMeta>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSeoMetaQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminSeoUrl = () => {




  return `/api/admin/seo`
}

export const getAdminSeo = async ( options?: RequestInit): Promise<SeoReport> => {

  return customFetch<SeoReport>(getGetAdminSeoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSeoQueryKey = () => {
    return [
    `/api/admin/seo`
    ] as const;
    }


export const getGetAdminSeoQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSeo>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSeo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSeoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSeo>>> = ({ signal }) => getAdminSeo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSeo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSeoQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSeo>>>
export type GetAdminSeoQueryError = ErrorType<unknown>



export function useGetAdminSeo<TData = Awaited<ReturnType<typeof getAdminSeo>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSeo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSeoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAdminStoreSeoUrl = (id: number,) => {




  return `/api/admin/seo/stores/${id}`
}

export const updateAdminStoreSeo = async (id: number,
    seoOverride: SeoOverride, options?: RequestInit): Promise<UpdateAdminStoreSeo200> => {

  return customFetch<UpdateAdminStoreSeo200>(getUpdateAdminStoreSeoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(seoOverride)
  }
);}




export const getUpdateAdminStoreSeoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminStoreSeo>>, TError,{id: number;data: BodyType<SeoOverride>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminStoreSeo>>, TError,{id: number;data: BodyType<SeoOverride>}, TContext> => {

const mutationKey = ['updateAdminStoreSeo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminStoreSeo>>, {id: number;data: BodyType<SeoOverride>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAdminStoreSeo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminStoreSeoMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminStoreSeo>>>
    export type UpdateAdminStoreSeoMutationBody = BodyType<SeoOverride>
    export type UpdateAdminStoreSeoMutationError = ErrorType<unknown>

    export const useUpdateAdminStoreSeo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminStoreSeo>>, TError,{id: number;data: BodyType<SeoOverride>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminStoreSeo>>,
        TError,
        {id: number;data: BodyType<SeoOverride>},
        TContext
      > => {
      return useMutation(getUpdateAdminStoreSeoMutationOptions(options));
    }

